import { Dispatch, SetStateAction } from 'react';

import { CreateSpeaker, Speaker } from '@/types/speakers.types';
import GlobalContainer from '@ui/container/global-container';
import Text from '@ui/text/text/text';
import OptionalComponent from '@ui/optional-component/optional-component';
import { GreenroomUserProfile } from '@/types/greenroom/profile.types';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Button from '@ui/buttons/button/button';

type TEditEmailProps = {
  workingSpeaker: Speaker | CreateSpeaker;
  setWorkingSpeaker: Dispatch<SetStateAction<Speaker | CreateSpeaker>>;
  greenroomProfile: GreenroomUserProfile | undefined;
  validEmail: boolean;
  setOpenInviteModal: (open: boolean) => void;
  savingCast: boolean;
  invitingCast: boolean;
};

const EditEmail = ({
  validEmail,
  workingSpeaker,
  setWorkingSpeaker,
  greenroomProfile,
  setOpenInviteModal,
  savingCast,
  invitingCast,
}: TEditEmailProps) => {
  return (
    <label htmlFor="email" className="flex-column gap-4">
      <Text design="GlobalIcoText3" className="P2 margin-l-16 flex ai-center gap-4">
        Email{' '}
        <OptionalComponent display={!!greenroomProfile}>
          <Text tag="span" design="GlobalIcoText2">
            *
          </Text>
        </OptionalComponent>
        <TooltipPortal
          styles={{ padding: '8px' }}
          tooltipContent={
            <Text color="var(--primitives-mode-1-gray-100)" className="P2">
              Required if they'll be joining as a remote presenter in Greenroom
            </Text>
          }
          childrenWrapperClass="flex"
        >
          <Icon name={ICONS.INFO_CIRCLE} size={10} />
        </TooltipPortal>
      </Text>
      <div style={{ position: 'relative' }}>
        <GlobalContainer<'input'>
          id="email"
          TagName="input"
          type="email"
          disabled={!!greenroomProfile}
          value={workingSpeaker?.email || ''}
          onChange={(e) => setWorkingSpeaker((prev) => ({ ...prev, email: e.target.value }))}
          css={`
            background-color: transparent;
            width: 100%;
            padding: 10px calc(${validEmail ? '97px' : '52px'} + 8px + 16px) 10px 16px;
            outline: none;
            border: 1px solid var(--global-ico-text-3);
            border-radius: 100px;
          `}
          className="P2"
          mode="GlobalIcoText1"
          placeholder="Add email"
        />
        <Button
          clear={!validEmail}
          disabled={!validEmail || savingCast || invitingCast || !!greenroomProfile || !workingSpeaker?.email?.length}
          design={validEmail ? 'LocalBttnSecHalfTransp' : undefined}
          borderRadius="100px"
          position="absolute"
          className={`flex pi-center top-4 right-4 ${validEmail ? '' : 'pointer-events-none'}`}
          height="calc(100% - 8px)"
          width={`calc(${validEmail ? '97px' : '52px'} + 8px + 16px)`}
          onClick={() => setOpenInviteModal(true)}
        >
          <Text
            whiteSpace="nowrap"
            design={validEmail ? undefined : 'GlobalIcoText3'}
            width="100%"
            className={`${validEmail ? 'L2' : 'P2'} text-center`}
          >
            {validEmail ? (greenroomProfile ? 'Invite sent' : 'Send invite') : 'optional'}
          </Text>
        </Button>
      </div>
    </label>
  );
};

export default EditEmail;
